import { createI18n } from 'vue-i18n'

import messages from 'src/i18n'

export type MessageLanguages = keyof typeof messages

// Type-define 'en-US' as the master schema for the resource
export type MessageSchema = typeof messages['en-GB']

/* eslint-disable @typescript-eslint/no-empty-interface */
declare module 'vue-i18n' {
  export interface DefineLocaleMessage extends MessageSchema {}
  export interface DefineDateTimeFormat {}
  export interface DefineNumberFormat {}
}
/* eslint-enable @typescript-eslint/no-empty-interface */

const Boot = ({ app }) => {
  const i18n = createI18n({
    locale: 'en-GB',
    legacy: false,
    messages,
    missingWarn: false,
    fallbackWarn: false,
    silentTranslationWarn: false,
  })

  app.use(i18n)
}

export default Boot
